/**
 * Track UTM consts
 */

/* global sessionStorage */
const trackUtmVars = () => {
  const utmParams = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign']
  const forms = document.querySelectorAll('.js-form,.js-steps-form-form') // 👈 ff checken of deze class klopt

  // Get URL parameters, eq. ?utm_source=something&utm_medium=someting etc
  const params = getQueryParams(document.location.search)

  // Test if sessionStorage is accessible
  if (typeof Storage !== 'undefined') {
    // Store the utm vars that are set in sessionStorage
    for (let key in utmParams) {
      key = utmParams[key]
      if (typeof params[key] !== 'undefined') {
        sessionStorage.setItem(key, params[key])
      }
    }
  }

  // If there's a form check if sessionStorage contains a utm parameter and an input field
  // And add it to it's value if it does
  // NOTE: ensure that the input have an id that correspond to the id, like <input type="hidden" name="utm_source" id="utm_source" />
  if (forms.length) {
    ;[...forms].forEach(form => {
      for (let key in utmParams) {
        key = utmParams[key]
        // TODO: testen
        const input = form.querySelector(`[name="${key}"]`)
        const storageItem = window.sessionStorage.getItem(key)
        if (input && storageItem) {
          input.value = storageItem
        }
      }
    })
  }

  /**
  * Split query params
  * @param  {string} qs url after ?
  * @return {array}    params as an arrary
  */
  function getQueryParams(qs) {
    qs = qs.split('+').join(' ')

    const params = {}
    let tokens
    const re = /[?&]?([^=]+)=([^&]*)/g

    while ((tokens = re.exec(qs))) {
      // eslint-disable-line
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
    }
    return params
  }
}

export default trackUtmVars



// WEBPACK FOOTER //
// ./src/js/modules/TrackUtmVars.js